// 通用工具:测距、测面、鼠标位置、添加百度街景图层、实时交通图层
import PanoComp from './PanoComponent';
import MeatureComp from './MeatureComponent';
const componentBase = (G as any).base.ComponentBase;
const component = componentBase.extend({
    // 属性
    options: {
        map: null,
        trfficLayer: null,
    },

    // 初始化
    initialize(options: any) {
        componentBase.prototype.initialize.call(this, options);
        this.currentLevel = this.getCurrentLevel();
    },
    //  销毁
    destroy() {
        componentBase.prototype.destroy.call(this);
        this.removeTrfficLayer();
    },

    load() {
        componentBase.prototype.load.call(this);

    },

    unload() {
        this.removeTrfficLayer(); // 移除实时交通图层
        componentBase.prototype.unload.call(this);
    },

    // 获取当前级别
    getCurrentLevel() {
        return Math.round(this.map.getZoomLevel());
    },

    // 初始化实时交通图层
    _initTrafficlayer(config: any) {
        let tlyr = this.map.findLayer('baidulukuang');
        if (!tlyr) {
            const url = config.egis.server + '/wrts/getTile';
            tlyr = new g2.carto.TrafficLayer({
                id: 'baidulukuang',
                name: '实时路况',
                url: '' + url,
                projection: 'baidu',
                clientId: config.egis.clientId,
                clientSecret: config.egis.clientSecret,
            });
            this.map.addLayer(tlyr);
        } else {
            this.setTrafficLayerVisible(true);
        }
        this.options.trfficLayer = tlyr;
    },

    // 移除实时交通图层
    removeTrfficLayer() {
        const trafficlayerRemove = this.map.findLayer('baidulukuang');
        if (!!trafficlayerRemove) {
            this.map.removeLayer(trafficlayerRemove);
        }
    },

    // 添加实时交通图层
    addTafficLayer() {
        this._initTrafficlayer(this.options.config);
    },

    // 控制图层显隐
    setTrafficLayerVisible(visible: boolean) {
        if (!!this.options.trfficLayer) {
            this.options.trfficLayer.setVisible(visible);
        }
    },

    // 设置图层透明度
    setTrafficLayerCapacity(capacity: number) {
        if (!!this.options.trfficLayer) {
            this.options.trfficLayer.setCapacity(capacity);
        }
    },

});

export default component;
